module.exports = __webpack_public_path__ + "img/promo-1.974088a1.png";